import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/wrongAnswerIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f50984a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal full" }
const _hoisted_2 = { class: "modalContent" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "d-block fs_18 white ln_21 mt-3"
}
const _hoisted_6 = { class: "w-100 mt-5 pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_localized_text, {
          localizedKey: "app_prodottoGiàRitirato!",
          text: "Prodotto già ritirato!",
          class: "fs_24 white d-block ln_21 text-uppercase mt-1"
        }),
        (_ctx.rescueDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_haiRitiratoQuestoProdottoInData:",
                text: "Hai ritirato questo prodotto in data:",
                class: "fs_18 white d-block"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(_ctx.rescueDate, "YYYY MMMM DD - HH:mm", false)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "secondaryButton w-75 mx-auto mb-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.callback()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_Chiudi",
            text: "Chiudi"
          })
        ]),
        _createElementVNode("button", {
          class: "primaryButton w-75 mx-auto",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.homeCallback()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_Home",
            text: "Home"
          })
        ])
      ])
    ])
  ]))
}